var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},[_c('HeaderTop'),_vm._t("default"),_c('BaseModal'),_c('BaseExpenseModal')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }